module.exports = __webpack_public_path__ + "static/media/www.1d880b48.svg";